import { formatCurrency } from '../../../app/currency';

export function normalizeForSearchToken(str) {
  if (str == null) return '';
  return String(str)
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');
}

export function defaultProductFilter(product) {
  const t = product.type || 'PRODUCT';
  const s = product.status || 'ACTIVE';
  return (t === 'PRODUCT' || t === 'SERVICE') && s === 'ACTIVE';
}

export function productInputLabel(product) {
  if (!product) return '';
  const name = (product.name || '').trim();
  const code = (product.code || '').trim();
  if (code && name) return name.length > 22 ? `${name.slice(0, 20)}… (${code})` : `${name} (${code})`;
  return name || code;
}

export function productOptionLabel(product) {
  if (!product) return '';
  const code = product.code ? ` (${product.code})` : '';
  return `${product.name || ''}${code}`;
}

export function skuInputLabel(sku) {
  if (!sku) return '';
  return sku.code || sku.id || '';
}

export function skuOptionLabel(sku) {
  if (!sku) return '';
  const price = sku.price != null ? ` — ${formatCurrency(sku.price)}` : '';
  const attrs = sku.attributes;
  if (attrs && typeof attrs === 'object' && !Array.isArray(attrs) && Object.keys(attrs).length > 0) {
    const attrStr = Object.entries(attrs)
      .map(([k, v]) => `${k}: ${v}`)
      .join(' | ');
    return `${sku.code || sku.id}${price} — ${attrStr}`;
  }
  return `${sku.code || sku.id}${price}`;
}

export function skuVariationLabel(sku) {
  if (!sku) return '';
  const label = (sku.label || '').trim();
  if (label) return label;
  const attrs = sku.attributes;
  if (attrs && typeof attrs === 'object' && !Array.isArray(attrs) && Object.keys(attrs).length > 0) {
    return Object.keys(attrs)
      .sort()
      .map((key) => `${key}: ${attrs[key]}`)
      .join(' · ');
  }
  return (sku.code || sku.id || '').trim();
}

export function filterProductOptions(options, { inputValue }) {
  const raw = (inputValue || '').trim();
  if (!raw) return options;
  const tokens = raw
    .split(/\s+/)
    .map((t) => normalizeForSearchToken(t))
    .filter(Boolean);
  if (!tokens.length) return options;
  return options.filter((p) => {
    const hay = normalizeForSearchToken(
      [p.name, p.code, p.description].filter(Boolean).join(' '),
    );
    return tokens.every((tok) => hay.includes(tok));
  });
}

export function filterSkuOptions(options, { inputValue }) {
  const raw = (inputValue || '').trim();
  if (!raw) return options;
  const tokens = raw
    .split(/\s+/)
    .map((t) => normalizeForSearchToken(t))
    .filter(Boolean);
  if (!tokens.length) return options;
  return options.filter((s) => {
    const parts = [s.code];
    const attrs = s.attributes;
    if (attrs && typeof attrs === 'object' && !Array.isArray(attrs)) {
      Object.entries(attrs).forEach(([k, v]) => {
        parts.push(k, v);
      });
    }
    const hay = normalizeForSearchToken(parts.filter(Boolean).join(' '));
    return tokens.every((tok) => hay.includes(tok));
  });
}
